export const LedgerRow = {
  flow: 'x',
  align: 'center flex-start',
  gap: 'Z',
  padding: 'Z A',
  borderBottom: '1px solid inkBorder',

  LedgerDate: { text: (el, s) => s.date || '', fontSize: 'Y', color: 'inkMuted', fontWeight: '500', minWidth: 'D' },
  Description: { text: (el, s) => s.description || '', fontSize: 'Z', color: 'inkText', flex: '2', fontWeight: '500' },
  Provider: { text: (el, s) => s.provider || '', fontSize: 'Y', color: 'inkMuted', flex: '1' },
  CDTCode: { text: (el, s) => s.cdtCode || '', fontSize: 'Y', color: 'inkMuted', fontWeight: '600', minWidth: 'C' },
  Charge: { text: (el, s) => s.charge || '', fontSize: 'Z', fontWeight: '600', color: 'red', minWidth: 'C', textAlign: 'right' },
  Payment: { text: (el, s) => s.payment || '', fontSize: 'Z', fontWeight: '600', color: 'green', minWidth: 'C', textAlign: 'right' },
  Adjustment: { text: (el, s) => s.adjustment || '', fontSize: 'Z', fontWeight: '600', color: 'amber', minWidth: 'C', textAlign: 'right' },
  Balance: { text: (el, s) => s.balance || '', fontSize: 'Z', fontWeight: '700', color: 'inkText', minWidth: 'C', textAlign: 'right' },
  InsurancePortion: { text: (el, s) => s.insurancePortion || '', fontSize: 'Y', color: 'inkMuted', minWidth: 'C', textAlign: 'right' }
}
